
export enum ProPadTypeCd {
	CA_BLUE = 'CaBlue',
	CA_BLUE_YELLOW = 'CaBlueYellow',
	US_BLUE = 'UsBlue',
	US_BLUE_YELLOW = 'UsBlueYellow',
	YELLOW = 'Yellow'}

